import { Component, input, InputSignal } from '@angular/core';
import { ActionButton } from '@ui/models/action-buttons';
import { MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { ButtonModule } from '@ui/form/button/button.module';
import { TranslatePipe } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';


@Component({
    selector: 'ui-dialog-actions',
    imports: [
        MatDialogActions,
        ButtonModule,
        TranslatePipe,
        MatDialogClose,
        AsyncPipe,
    ],
    templateUrl: './dialog-actions.html',
    styleUrl: './dialog-actions.scss',
})
export class DialogActions {
    public readonly actions: InputSignal<ActionButton[] | null> = input(null);
}
